import { render, staticRenderFns } from "./dividendShare.vue?vue&type=template&id=72225e76&scoped=true"
import script from "./dividendShare.vue?vue&type=script&lang=js"
export * from "./dividendShare.vue?vue&type=script&lang=js"
import style0 from "./dividendShare.vue?vue&type=style&index=0&id=72225e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72225e76",
  null
  
)

export default component.exports